// Header/index.js
import { connect } from 'react-redux';
import Header from '../../components/Header';

import {
  changeTabValueInHeaderDispatch,
  openChangePasswordDialogDispatch,
  setLoggedInUserDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    visibleTab: state.general.visibleTab,
    showProgressBar:
      state.branches.allBranches.isLoading ||
      state.companies.allCompanies.isLoading ||
      state.users.allUsers.isLoading
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onChangeTabValueInHeader: (newValue) => {
      dispatch(changeTabValueInHeaderDispatch(newValue));
    },
    onChangePassword: () => {
      dispatch(openChangePasswordDialogDispatch(true));
    },
    setLoggedInUser: (user) => {
      dispatch(setLoggedInUserDispatch(user));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
